import { put, takeLatest } from 'redux-saga/effects'

import { NotificationManager } from '@/components/Notification'
import { ProductService } from '@/services'
import {
  getClassTypesAndProductCount,
  getClassTypesAndProductCountError,
  getClassTypesAndProductCountSuccess,
  getProductsByClassType,
  getProductsByClassTypeError,
  getProductsByClassTypeSuccess,
  getProductSubCategoryOverviewData,
  getProductSubCategoryOverviewDataError,
  getProductSubCategoryOverviewDataSuccess,
  getSubmenuProductCategoryList,
  getSubmenuProductCategoryListError,
  getSubmenuProductCategoryListSuccess,
} from '@/store/slices/categorySlice'
import { isEmptyObject } from '@/libs/utils/object'

function removeFaultyProductCategory(data) {
  return data?.categories?.filter(
    (category) => isEmptyObject(category) === false,
  )
}

function* getSubmenuProductCategoryListSaga() {
  try {
    const { data } = yield ProductService.getSubmenuProductCategoryList()

    const modifiedData = removeFaultyProductCategory(data)
    yield put(getSubmenuProductCategoryListSuccess(modifiedData))
  } catch (error) {
    console.error('Error fetching submenu product category list:', error)
    yield put(getSubmenuProductCategoryListError())
    NotificationManager.error({
      message: 'notification.error.load',
    })
  }
}

function* getClassTypesAndProductCountSaga({ payload: { subCategoryId } }) {
  try {
    const { data } = yield ProductService.getClassTypesAndProductCount(
      +subCategoryId,
    )

    yield put(getClassTypesAndProductCountSuccess(data))
  } catch (error) {
    console.error('Error fetching class types and product count:', error)
    yield put(getClassTypesAndProductCountError())
    NotificationManager.error({
      message: 'notification.error.load',
    })
  }
}

function* getProductsByClassTypeSaga({
  payload: {
    categoryId,
    pageNumber,
    sortOrder = 1,
    pageSize = 12,
    onlyProduct = false,
  },
}) {
  try {
    const { data } = yield ProductService.getProductsByClassType(
      +categoryId,
      pageNumber,
      sortOrder,
      pageSize,
    )

    yield put(getProductsByClassTypeSuccess({ data, onlyProduct }))
  } catch (error) {
    console.error('Error fetching products by class type:', error)
    yield put(getProductsByClassTypeError())
    NotificationManager.error({
      message: 'notification.error.load',
    })
  }
}

function* getProductSubCategoryOverviewDataSaga({ payload }) {
  const { categoryId } = payload
  try {
    const response = yield ProductService.getProductSubCategoryOverviewData(categoryId)
    yield put(getProductSubCategoryOverviewDataSuccess(response.data))
  } catch (error) {
    console.error('Error fetching product sub-category overview data:', error)
    yield put(getProductSubCategoryOverviewDataError())
    NotificationManager.error({
      message: 'notification.error.load',
    })
  }
}

export default function* categorySaga() {
  yield takeLatest(
    getSubmenuProductCategoryList.type.toString(),
    getSubmenuProductCategoryListSaga,
  )
  yield takeLatest(
    getClassTypesAndProductCount.type.toString(),
    getClassTypesAndProductCountSaga,
  )
  yield takeLatest(
    getProductsByClassType.type.toString(),
    getProductsByClassTypeSaga,
  )
  yield takeLatest(
    getProductSubCategoryOverviewData.type.toString(),
    getProductSubCategoryOverviewDataSaga,
  )
}
